import { MenuItem } from '@/app/components/MainNavigation/MainNavigation';
import { Routes } from '@/app/enums';

const aboutUs = {
  titleTranslationKey: 'components.MainNavigation.aboutUsSection',
  dropdownItems: [
    {
      titleTranslationKey: 'components.MainNavigation.howDoesItWork',
      path: Routes.HOW_DOES_IT_WORK,
    },
    {
      titleTranslationKey: 'components.MainNavigation.aboutUsLink',
      path: Routes.ABOUT_US,
    },
  ],
};

export const mainNavigationItemsForCZ: MenuItem[] = [
  {
    titleTranslationKey: 'components.MainNavigation.regularDonor',
    path: Routes.REGULAR_DONOR,
    isHighlighted: true,
  },
  {
    titleTranslationKey: 'components.MainNavigation.charityCollections',
    descriptionTranslationKey: 'components.MainNavigation.charityCollectionsDescription',
    dropdownItems: [
      {
        titleTranslationKey: 'components.MainNavigation.charityCollections',
        path: Routes.CHARITY_COLLECTIONS,
      },
      {
        titleTranslationKey: 'components.MainNavigation.activeCollections',
        path: Routes.ACTIVE_COLLECTIONS,
      },
      {
        titleTranslationKey: 'components.MainNavigation.finishedCollections',
        path: Routes.FINISHED_COLLECTIONS,
      },
      {
        titleTranslationKey: 'components.MainNavigation.aboutCharityCrowdfunding',
        path: Routes.ABOUT_CHARITY_CROWDFUNDING,
      },
    ],
  },
  {
    titleTranslationKey: 'components.MainNavigation.commercialProjects',
    descriptionTranslationKey: 'components.MainNavigation.commercialProjectsDescription',
    dropdownItems: [
      {
        titleTranslationKey: 'components.MainNavigation.commercialProjects',
        path: Routes.COMMERCIAL_PROJECTS,
      },
      {
        titleTranslationKey: 'components.MainNavigation.activeProjects',
        path: Routes.ACTIVE_PROJECTS,
      },
      {
        titleTranslationKey: 'components.MainNavigation.finishedProjects',
        path: Routes.FINISHED_PROJECTS,
      },
      {
        titleTranslationKey: 'components.MainNavigation.aboutRewardCrowdfunding',
        path: Routes.ABOUT_REWARD_CROWDFUNDING,
      },
    ],
  },
  aboutUs,
];

export const mainNavigationItemsForSK: MenuItem[] = [
  {
    titleTranslationKey: 'components.MainNavigation.charityCollections',
    dropdownItems: [
      {
        titleTranslationKey: 'components.MainNavigation.charityCollections',
        path: Routes.CHARITY_COLLECTIONS,
      },
      {
        titleTranslationKey: 'components.MainNavigation.activeCollections',
        path: Routes.ACTIVE_COLLECTIONS,
      },
      {
        titleTranslationKey: 'components.MainNavigation.finishedCollections',
        path: Routes.FINISHED_COLLECTIONS,
      },
      {
        titleTranslationKey: 'components.MainNavigation.togetherForUkraine',
        path: Routes.TOGETHER_FOR_UKRAINE,
      },
      {
        titleTranslationKey: 'components.MainNavigation.aboutOnlineFundraising',
        path: Routes.ABOUT_ONLINE_FUNDRAISING,
      },
    ],
  },
  {
    titleTranslationKey: 'components.MainNavigation.startProject',
    dropdownItems: [
      {
        titleTranslationKey: 'components.MainNavigation.startProject',
        path: Routes.START_PROJECT,
      },
      {
        titleTranslationKey: 'components.MainNavigation.activeCampaigns',
        path: Routes.START_PROJECT_ACTIVE_CAMPAIGNS,
      },
      {
        titleTranslationKey: 'components.MainNavigation.finishedCampaigns',
        path: Routes.START_PROJECT_FINISHED_CAMPAIGNS,
      },
      {
        titleTranslationKey: 'components.MainNavigation.aboutRewardCrowdfunding',
        path: Routes.ABOUT_REWARD_CROWDFUNDING,
      },
    ],
  },
  {
    titleTranslationKey: 'components.MainNavigation.whoAreWeHereFor',
    dropdownItems: [
      {
        titleTranslationKey: 'components.MainNavigation.individuals',
        path: Routes.INDIVIDUALS,
      },
      {
        titleTranslationKey: 'components.MainNavigation.nonprofitOrganizations',
        path: Routes.NGOS,
      },
      {
        titleTranslationKey: 'components.MainNavigation.companies',
        path: Routes.COMPANIES,
      },
      {
        titleTranslationKey: 'components.MainNavigation.partners',
        path: Routes.PARTNERS,
      },
      {
        titleTranslationKey: 'components.MainNavigation.ambassadors',
        path: Routes.AMBASSADORS,
      },
      {
        titleTranslationKey: 'components.MainNavigation.media',
        path: Routes.MEDIA,
      },
    ],
  },
  aboutUs,
];
